import { Component, OnInit, ViewChild } from "@angular/core";
import { PageEvent } from "@angular/material/paginator";
import { ActivatedRoute } from "@angular/router";
import { DashboardService } from "src/app/services/dashboard.service";
import { ChartComponent } from "ng-apexcharts";

import {
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexChart,
} from "ng-apexcharts";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
};
@Component({
  selector: "app-fuel-expenses",
  templateUrl: "./fuel-expenses.component.html",
  styleUrls: ["./fuel-expenses.component.scss"],
})
export class FuelExpensesComponent implements OnInit {
  selectedCar: any;
  userVehicles: any[] = [];
  fuelExpenses: any[] = [];
  pageEvent: PageEvent;
  totalRecords = 0;
  search: any = {
    page: 0,
    size: 5,
    userId: "",
    vehicleId: "",
  };
  refuellingExpenseForm!: FormGroup;
  submitted = false;
  @ViewChild("chart") chart: ChartComponent;
  @ViewChild("addFuelExpenseModal") addFuelExpenseModal: any;
  public chartOptions: Partial<ChartOptions>;

  expenseMetricsData: any;

  constructor(
    private route: ActivatedRoute,
    private dashboardService: DashboardService,
    private fb: FormBuilder,
    private modalService: NgbModal
  ) {
    this.search.userId = this.route.snapshot.params.id;
    this.chartOptions = {
      series: [44, 55, 13, 43, 22],
      chart: {
        width: 380,
        type: "pie",
      },
      labels: ["Team A", "Team B", "Team C", "Team D", "Team E"],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    };
  }

  ngOnInit(): void {
    this.getVehiclesOfuser();
    // this.getfuelData();
  }

  getfuelData() {
    this.getFuelExpenses();
    this.getFuelExpenseMetrics();
  }

  buildForm() {
    this.refuellingExpenseForm = this.fb.group({
      fillUpDate: [null],
      vehicle: [this.userVehicles?.[0]],
      odometerReading: [null],
      totalFuelExpense: [null],
      fuelInLitres: [null],
      fuelType: [this.userVehicles?.[0].fuelType],
      pricePerLiter: [null],
    });
  }
  calculateFuelInLiters() {
    const totalFuelExpense =
      this.refuellingExpenseForm.get("totalFuelExpense")?.value;
    const pricePerLiter =
      this.refuellingExpenseForm.get("pricePerLiter")?.value;
    const fuelInLitres = (totalFuelExpense / pricePerLiter).toFixed(2);
    this.refuellingExpenseForm.get("fuelInLitres")?.setValue(+fuelInLitres);
  }
  onCarSelect(item: any) {
    console.log(item);
    this.selectedCar = item;
    this.search.vehicleId = item?.userVehicleId;
    this.search.page = 0;
    this.search.size = 5;
    this.getfuelData();
  }

  getVehiclesOfuser() {
    this.dashboardService.getUserVehicles(this.search.userId).subscribe(
      (res: any) => {
        this.userVehicles = res.userVehicles;
        this.buildForm();
        this.selectedCar = res.userVehicles[0];
        this.search.vehicleId=this.selectedCar.userVehicleId
        this.getfuelData();
      },
      (error) => {
        console.error(error);
      }
    );
  }

  getFuelExpenses() {
    this.dashboardService.getFuelExpenses(this.search).subscribe(
      (res: any) => {
        this.fuelExpenses = res.fuelExpenseLogs;
        this.totalRecords = res.totalRecords;
      },
      (error) => {
        console.error(error);
      }
    );
  }
  onEditClick(item: any) {
    console.log(item);
  }

  getServerData(ev: PageEvent) {
    this.search.page = ev.pageIndex;
    this.search.size = ev.pageSize;
    this.getFuelExpenses();
    return ev;
  }

  onAddRefuellingExpenseClick() {
    this.modalService.open(this.addFuelExpenseModal, { centered: true });
  }

  addRefuellingExpense() {
    this.submitted = true;
    if (this.refuellingExpenseForm.valid) {
      const payload = JSON.parse(
        JSON.stringify(this.refuellingExpenseForm.value)
      );
      payload.fillUpDate = new Date(payload.fillUpDate)
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");
      delete payload.vehicle;
      this.dashboardService
        .addFuelExpense(
          this.refuellingExpenseForm.value.vehicle.userVehicleId,
          payload
        )
        .subscribe(
          (res: any) => {
            this.modalService.dismissAll();
            this.getfuelData();
          },
          (error) => {
            console.error(error);
          }
        );
    }
  }

  calculatePricePerLiter() {
    const totalFuelExpense =
      this.refuellingExpenseForm.get("totalFuelExpense")?.value;
    const fuelInLitres = this.refuellingExpenseForm.get("fuelInLitres")?.value;
    const pricePerLiter = (totalFuelExpense / fuelInLitres).toFixed(2);
    this.refuellingExpenseForm.get("pricePerLiter")?.setValue(+pricePerLiter);
  }

  onAddFuelExpenseVehicleChange() {
    const selectedVehicle = this.refuellingExpenseForm.get("vehicle")?.value;
    this.refuellingExpenseForm
      .get("fuelType")
      ?.setValue(selectedVehicle.fuelType);
  }

  getFuelExpenseMetrics() {
    this.dashboardService.getFuelExpenseMetrics(this.search).subscribe(
      (res: any) => {
        this.expenseMetricsData = res;
        this.chartOptions = {
          series: [
            res.totalKmsTravelledWithoutApp,
            res.totalKmsTravelledWithApp,
            res.fuelEfficientKms,
          ],
          chart: {
            width: 380,
            type: "pie",
          },
          labels: [
            `Total km travelled - ${res.totalKmsTravelledWithoutApp}`,
            `Km with fuelshine app  - ${res.totalKmsTravelledWithApp}`,
            `Fuel efficient km  - ${res.fuelEfficientKms}`,
          ],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  position: "bottom",
                },
              },
            },
          ],
        };
      },
      (error) => {
        console.error(error);
      }
    );
  }
}
